$(document).on('turbolinks:load', function () {
  if ($('body').hasClass('instagram_agents')) {
    const promptTextarea = document.getElementById('instagram_agent_prompt');
    const postsPromptTextarea = document.getElementById('instagram_agent_posts_prompt');
    const charCountSpan = document.getElementById('prompt-char-count');
    const limitWrapper = document.getElementById('prompt-max-limit-wrapper');
    const limitSpan = document.getElementById('prompt-max-limit');

    const postsCharCountSpan = document.getElementById('posts-prompt-char-count');
    const postsLimitWrapper = document.getElementById('posts-prompt-max-limit-wrapper');
    const postsLimitSpan = document.getElementById('posts-prompt-max-limit');

    function updatePromptCount() {
      const isSendfy = $("#instagram_agent_model_llm").val() === "sendfy";

      if (promptTextarea && charCountSpan) {
        const limit = parseInt(promptTextarea.getAttribute('data-limit') || 10000);
        const currentLength = promptTextarea.value.length;
        charCountSpan.textContent = currentLength;

        if (isSendfy) {
          if (limitWrapper) $(limitWrapper).show();
          if (limitSpan) limitSpan.textContent = limit;
          promptTextarea.setAttribute('maxlength', limit);
          if (currentLength > limit) {
            charCountSpan.classList.add('text-danger');
          } else {
            charCountSpan.classList.remove('text-danger');
          }
        } else {
          if (limitWrapper) $(limitWrapper).hide();
          promptTextarea.removeAttribute('maxlength');
          charCountSpan.classList.remove('text-danger');
        }
      }

      if (postsPromptTextarea && postsCharCountSpan) {
        const limit = parseInt(postsPromptTextarea.getAttribute('data-limit') || 10000);
        const currentLength = postsPromptTextarea.value.length;
        postsCharCountSpan.textContent = currentLength;

        if (isSendfy) {
          if (postsLimitWrapper) $(postsLimitWrapper).show();
          if (postsLimitSpan) postsLimitSpan.textContent = limit;
          postsPromptTextarea.setAttribute('maxlength', limit);
          if (currentLength > limit) {
            postsCharCountSpan.classList.add('text-danger');
          } else {
            postsCharCountSpan.classList.remove('text-danger');
          }
        } else {
          if (postsLimitWrapper) $(postsLimitWrapper).hide();
          postsPromptTextarea.removeAttribute('maxlength');
          postsCharCountSpan.classList.remove('text-danger');
        }
      }
    }

    function check_llm() {
      const currentModelLlm = $("#instagram_agent_model_llm").val();
      const limit = parseInt(promptTextarea ? (promptTextarea.getAttribute('data-limit') || 10000) : 10000);

      $(".llm-select").show();
      $("#instagram_agent_llm").show();
      $("#instagram_agent_gpt_key").show();

      if (currentModelLlm == "gemini") {
        $(".get_gemini_llms").show();
        $(".get_openai_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").attr('href', 'https://aistudio.google.com/app/apikey');
      } else if (currentModelLlm == "openai") {
        $(".get_openai_llms").show();
        $(".get_gemini_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").attr('href', 'https://platform.openai.com/api-keys');
      } else if (currentModelLlm == "openrouter") {
        $(".get_openrouter_llms").show();
        $(".get_gemini_llms").hide();
        $(".get_openai_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").attr('href', 'https://openrouter.ai/settings/keys');
      } else if (currentModelLlm == "groq") {
        $(".get_groq_llms").show();
        $(".get_openai_llms").hide();
        $(".get_gemini_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".api_gpt_key").attr('href', 'https://console.groq.com/keys');
      } else if (currentModelLlm == "sendfy") {
        $(".llm-select").hide();
        $(".get_openai_llms").hide();
        $(".get_gemini_llms").hide();
        $(".get_openrouter_llms").hide();
        $(".get_groq_llms").hide();
        $(".api_gpt_key").hide();
        $("#instagram_agent_llm").hide();
        $("#instagram_agent_gpt_key").hide();

        if (promptTextarea && promptTextarea.value.length > limit) {
          alert('Atenção: O prompt de DM atual possui ' + promptTextarea.value.length + ' caracteres. Para utilizar a IA da Sendfy, o limite máximo é de ' + limit + ' caracteres.');
        }
      }

      updatePromptCount();
    }

    $("#instagram_agent_model_llm").on('change', function (e) {
      check_llm();
    });

    if (promptTextarea) {
      $(promptTextarea).on('input keyup paste', function () {
        updatePromptCount();
      });
    }

    if (postsPromptTextarea) {
      $(postsPromptTextarea).on('input keyup paste', function () {
        updatePromptCount();
      });
    }

    $(document).on('submit', '#instagram_agent_form', function (e) {
      const isSendfy = $("#instagram_agent_model_llm").val() === "sendfy";
      if (isSendfy) {
        if (promptTextarea) {
          const limit = parseInt(promptTextarea.getAttribute('data-limit') || 10000);
          if (promptTextarea.value.length > limit) {
            e.preventDefault();
            alert('Atenção! Não é possível salvar: O prompt de DM possui ' + promptTextarea.value.length + ' caracteres (limite: ' + limit + ').');
            promptTextarea.focus();
            return false;
          }
        }
        if (postsPromptTextarea) {
          const limit = parseInt(postsPromptTextarea.getAttribute('data-limit') || 10000);
          if (postsPromptTextarea.value.length > limit) {
            e.preventDefault();
            alert('Atenção! Não é possível salvar: O prompt geral de postagens possui ' + postsPromptTextarea.value.length + ' caracteres (limite: ' + limit + ').');
            postsPromptTextarea.focus();
            return false;
          }
        }
      }
    });

    check_llm();

    window.launchInstagramSignup = function (instagram_agent_id) {
      window.location.href = `/connect_facebook?id=${instagram_agent_id}`;
    };

    // --- CARREGAMENTO DE POSTAGENS E PROMPTS CUSTOMIZADOS ---
    const btnFetchPosts = document.getElementById('btn-fetch-instagram-posts');
    if (btnFetchPosts) {
      const agentId = btnFetchPosts.getAttribute('data-agent-id');
      let currentNextCursor = null;

      function loadInstagramPosts(afterCursor = null) {
        if (!afterCursor) {
          $('#posts-loading-spinner').show();
          $('#posts-error-alert').hide().text('');
          $('#instagram-posts-list').html('');
          $('#load-more-posts-container').hide();
          currentNextCursor = null;
        } else {
          $('#btn-load-more-posts').prop('disabled', true).html('<span class="spinner-border spinner-border-sm mr-1"></span> Carregando...');
        }

        const reqData = afterCursor ? { after: afterCursor } : {};

        $.ajax({
          url: `/instagram_agents/${agentId}/fetch_posts`,
          method: 'GET',
          data: reqData,
          dataType: 'json',
          success: function (data) {
            $('#posts-loading-spinner').hide();
            $('#btn-load-more-posts').prop('disabled', false).html('<i class="ni ni-cloud-download-95 mr-1"></i> Carregar mais postagens');

            if (data.status && data.posts) {
              renderInstagramPosts(data.posts, !!afterCursor);
              currentNextCursor = data.next_cursor || null;

              if (data.has_next_page && currentNextCursor) {
                $('#load-more-posts-container').show();
              } else {
                $('#load-more-posts-container').hide();
              }
            } else {
              $('#posts-error-alert').show().text(data.error || 'Não foi possível carregar as postagens.');
            }
          },
          error: function (xhr) {
            $('#posts-loading-spinner').hide();
            $('#btn-load-more-posts').prop('disabled', false).html('<i class="ni ni-cloud-download-95 mr-1"></i> Carregar mais postagens');
            const err = xhr.responseJSON ? xhr.responseJSON.error : 'Erro ao buscar postagens.';
            $('#posts-error-alert').show().text(err);
          }
        });
      }

      function renderInstagramPosts(posts, append = false) {
        if (posts.length === 0 && !append) {
          $('#instagram-posts-list').html('<div class="col-12 text-center py-4 text-muted"><p>Nenhuma postagem encontrada nesta conta de Instagram.</p></div>');
          return;
        }

        let html = '';
        posts.forEach(function (post) {
          const isVideo = post.media_type === 'VIDEO';
          const thumbUrl = post.thumbnail_url || post.media_url;

          const mediaThumb = thumbUrl ? (
            isVideo ? `<div class="position-relative media-preview-thumb" data-media-url="${post.media_url}" data-thumbnail-url="${thumbUrl}" data-media-type="${post.media_type}" data-caption="${escapeHtml(post.caption)}" style="cursor: pointer;">
                        <img src="${thumbUrl}" class="card-img-top" style="object-fit: cover; filter: brightness(0.85);">
                        <i class="ni ni-button-play position-absolute text-white" style="top: 40%; left: 42%; font-size: 2.5rem; text-shadow: 0 0 10px rgba(0,0,0,0.8);"></i>
                       </div>`
              : `<div class="media-preview-thumb" data-media-url="${post.media_url}" data-thumbnail-url="${thumbUrl}" data-media-type="${post.media_type}" data-caption="${escapeHtml(post.caption)}" style="cursor: pointer;">
                        <img src="${thumbUrl}" class="card-img-top" style="object-fit: cover; transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.03)'" onmouseout="this.style.transform='scale(1)'">
                       </div>`
          ) : `<div class="p-4 bg-secondary text-center text-muted"><i class="ni ni-image font-size-xl"></i> Sem imagem</div>`;

          const typeBadge = post.media_type === 'VIDEO' ? '<span class="badge badge-warning" style="font-size: 0.75rem;"><i class="ni ni-button-play mr-1"></i> Vídeo / Reels</span>'
                          : (post.media_type === 'CAROUSEL_ALBUM' ? '<span class="badge badge-info" style="font-size: 0.75rem;"><i class="ni ni-albums mr-1"></i> Carrossel</span>'
                          : '<span class="badge badge-light" style="font-size: 0.75rem;"><i class="ni ni-image mr-1"></i> Imagem</span>');
          
          const captionShort = post.caption && post.caption.length > 100 ? post.caption.substring(0, 100) + '...' : (post.caption || '');

          html += `
            <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div class="card bg-dark text-white border-secondary h-100 shadow-sm" id="post-card-${post.media_id}">
                ${mediaThumb}
                <div class="card-body d-flex flex-column">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="badge badge-pill ${post.has_custom_prompt ? 'badge-success' : 'badge-secondary'}">
                      ${post.has_custom_prompt ? 'Prompt Customizado' : 'Prompt Geral'}
                    </span>
                    ${typeBadge}
                  </div>
                  <div class="text-right mb-2">
                    <small class="text-muted"><i class="ni ni-calendar-grid-58 mr-1"></i>${formatDate(post.timestamp)}</small>
                  </div>

                  <p class="card-text text-sm mb-3 text-light" title="${escapeHtml(post.caption)}">
                    <strong>Legenda:</strong> ${escapeHtml(captionShort || 'Sem legenda')}
                  </p>

                  <div class="form-group mb-3">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input post-enable-toggle" id="enable_post_${post.media_id}" ${post.enable ? 'checked' : ''}>
                      <label class="custom-control-label text-white" for="enable_post_${post.media_id}">Ativar Prompt Específico</label>
                    </div>
                  </div>

                  <div class="form-group mb-3">
                    <label class="form-control-label text-sm text-white">Prompt Específico do Post:</label>
                    <textarea class="form-control post-prompt-input" id="prompt_post_${post.media_id}" rows="3" placeholder="Digite aqui o prompt exclusivo para responder aos comentários desta imagem...">${escapeHtml(post.prompt)}</textarea>
                  </div>

                  <div class="form-group mb-2 mt-2 pt-2 border-top border-secondary">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input post-private-enable-toggle" id="enable_private_msg_${post.media_id}" ${post.private_message_enable ? 'checked' : ''}>
                      <label class="custom-control-label text-white" for="enable_private_msg_${post.media_id}">Enviar Mensagem no Privado (DM)</label>
                    </div>
                  </div>

                  <div class="form-group flex-grow-1">
                    <label class="form-control-label text-sm text-white">Mensagem no Privado (DM):</label>
                    <textarea class="form-control post-private-msg-input" id="private_msg_${post.media_id}" rows="3" placeholder="Digite a mensagem para enviar no Direct ao usuário (ex: link de grupo, convite)...">${escapeHtml(post.private_message)}</textarea>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mt-2">
                    ${post.permalink ? `<a href="${post.permalink}" target="_blank" class="btn btn-sm btn-outline-light"><i class="ni ni-bold-right mr-1"></i> Ver no IG</a>` : '<div></div>'}
                    <button type="button" class="btn btn-sm btn-success btn-save-post-prompt" data-media-id="${post.media_id}" data-caption="${escapeHtml(post.caption)}" data-media-url="${post.media_url}" data-permalink="${post.permalink}" data-media-type="${post.media_type}">
                      <i class="ni ni-check-bold mr-1"></i> Salvar Post
                    </button>
                  </div>
                  <small class="save-status-msg text-right text-success mt-1" style="display:none;"></small>
                </div>
              </div>
            </div>
          `;
        });

        if (append) {
          $('#instagram-posts-list').append(html);
        } else {
          $('#instagram-posts-list').html(html);
        }
      }

      $(btnFetchPosts).on('click', function () {
        loadInstagramPosts();
      });

      $(document).on('click', '#btn-load-more-posts', function () {
        if (currentNextCursor) {
          loadInstagramPosts(currentNextCursor);
        }
      });

      // Carregar automaticamente se trocar para a aba de posts pela primeira vez
      $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        if (e.target.id === 'posts-tab') {
          if ($('#instagram-posts-list').children().length === 0) {
            loadInstagramPosts();
          }
        }
      });

      // Salvar prompt do post via AJAX
      $(document).on('click', '.btn-save-post-prompt', function () {
        const btn = $(this);
        const mediaId = btn.attr('data-media-id');
        const caption = btn.attr('data-caption');
        const mediaUrl = btn.attr('data-media-url');
        const permalink = btn.attr('data-permalink');
        const mediaType = btn.attr('data-media-type');
        const promptVal = $(`#prompt_post_${mediaId}`).val();
        const enableVal = $(`#enable_post_${mediaId}`).is(':checked');
        const privateMsgEnableVal = $(`#enable_private_msg_${mediaId}`).is(':checked');
        const privateMsgVal = $(`#private_msg_${mediaId}`).val();

        const card = $(`#post-card-${mediaId}`);
        const statusMsg = card.find('.save-status-msg');

        btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status"></span> Salvando...');

        $.ajax({
          url: `/instagram_agents/${agentId}/save_post_prompt`,
          method: 'POST',
          dataType: 'json',
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
          },
          data: {
            post: {
              media_id: mediaId,
              caption: caption,
              media_url: mediaUrl,
              permalink: permalink,
              media_type: mediaType,
              prompt: promptVal,
              enable: enableVal,
              private_message_enable: privateMsgEnableVal,
              private_message: privateMsgVal
            }
          },
          success: function (res) {
            btn.prop('disabled', false).html('<i class="ni ni-check-bold mr-1"></i> Salvar Post');
            if (res.status) {
              statusMsg.text('Salvo com sucesso!').show().fadeOut(3000);
              const badge = card.find('.badge');
              if (promptVal.trim().length > 0 && enableVal) {
                badge.removeClass('badge-secondary').addClass('badge-success').text('Prompt Customizado Ativo');
              } else {
                badge.removeClass('badge-success').addClass('badge-secondary').text('Usando Prompt Geral');
              }
            } else {
              alert('Erro ao salvar prompt do post: ' + (res.errors ? res.errors.join(', ') : 'Erro desconhecido.'));
            }
          },
          error: function (xhr) {
            btn.prop('disabled', false).html('<i class="ni ni-check-bold mr-1"></i> Salvar Post');
            alert('Erro ao salvar o prompt do post.');
          }
        });
      });

      // Preview da imagem/vídeo no modal ao clicar na thumbnail
      $(document).on('click', '.media-preview-thumb', function () {
        const mediaUrl = $(this).attr('data-media-url');
        const thumbUrl = $(this).attr('data-thumbnail-url');
        const mediaType = $(this).attr('data-media-type');
        const caption = $(this).attr('data-caption');

        let content = '';
        if (mediaType === 'VIDEO' && mediaUrl && mediaUrl !== 'null') {
          content = `<video src="${mediaUrl}" controls style="max-width: 100%; max-height: 500px; border-radius: 8px;"></video>`;
        } else {
          content = `<img src="${thumbUrl || mediaUrl}" style="max-width: 100%; max-height: 500px; border-radius: 8px; object-fit: contain;">`;
        }

        $('#mediaModalContent').html(content);
        $('#mediaModalCaption').text(caption || 'Sem legenda');
        $('#mediaPreviewModal').modal('show');
      });
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatDate(ts) {
      if (!ts) return '';
      try {
        const d = new Date(ts);
        return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
      } catch (e) {
        return ts;
      }
    }
  }
});
